module.exports = __webpack_public_path__ + "static/media/arrow.1122ac5e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/arrow.svg
// module id = 164
// module chunks = 0